// Mock data for Sachdeva Sons Indian Ethnic Wear Store

export const featuredProducts = [
  {
    id: 1,
    name: "Rose Gold Embroidered Georgette Suit",
    price: 5999,
    originalPrice: 9999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/pr6y97xh_8A0A482A-1208-41D3-A02F-CC70B68ABFCD.png",
    category: "Georgette Collection",
    discount: "40% OFF",
    rating: 4.9,
    reviews: 156,
    fabric: "Premium Georgette with soft texture and graceful drape",
    style: "Straight cut suit with flared bottom and flowing dupatta",
    color: "Rose gold with subtle pink undertones and gold accents",
    work: "Intricate floral embroidery with zari, sequins, and mirror work",
    description: "This exquisite rose gold georgette suit features delicate embroidery work throughout, perfect for festive celebrations. The lightweight fabric ensures comfort while the rich embellishments add a touch of luxury."
  },
  {
    id: 2,
    name: "Grey Gold Embellished Party Wear",
    price: 6999,
    originalPrice: 11999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/hgp6zivg_IMG_0362.jpeg",
    category: "Party Wear",
    discount: "42% OFF",
    rating: 4.8,
    reviews: 198,
    fabric: "Luxurious silk blend with shimmer finish",
    style: "Anarkali style with flared silhouette and embellished neckline",
    color: "Elegant grey with rich gold embellishments",
    work: "Heavy gold zari work with sequins and bead detailing",
    description: "A stunning party wear ensemble in sophisticated grey and gold. The heavy embellishment work makes it perfect for weddings and grand celebrations."
  },
  {
    id: 3,
    name: "Black Gold Embroidered Festive Suit",
    price: 5499,
    originalPrice: 8999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/qqawma5m_IMG_0359.jpeg",
    category: "Pakistani Suits",
    discount: "39% OFF",
    rating: 4.7,
    reviews: 143,
    fabric: "Fine cotton with embroidered panels",
    style: "Pakistani straight cut with narrow pants and printed dupatta",
    color: "Classic black with gold embroidery highlights",
    work: "Traditional gold thread embroidery with floral motifs",
    description: "This elegant black suit features beautiful gold embroidery perfect for festive occasions. The classic color combination ensures timeless elegance."
  },
  {
    id: 4,
    name: "Golden Organza Embroidered Ensemble",
    price: 7999,
    originalPrice: 13999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ceavocb0_IMG_0408.jpeg",
    category: "Organza Suits",
    discount: "43% OFF",
    rating: 4.9,
    reviews: 221
  },
  {
    id: 5,
    name: "Lavender Silk Embroidered Saree",
    price: 8999,
    originalPrice: 15999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/96bmg28p_IMG_0405.jpeg",
    category: "Silk Collection",
    discount: "44% OFF",
    rating: 5.0,
    reviews: 287
  },
  {
    id: 6,
    name: "Black Zari Party Wear Suit",
    price: 6499,
    originalPrice: 10999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/frkff2os_IMG_0373.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 4.8,
    reviews: 189
  },
  {
    id: 7,
    name: "Pink Embroidered Georgette Suit",
    price: 5999,
    originalPrice: 9999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ph9dqip8_IMG_0371.jpeg",
    category: "Georgette Collection",
    discount: "40% OFF",
    rating: 4.9,
    reviews: 176
  },
  {
    id: 8,
    name: "Bright Yellow Silk Festive Suit",
    price: 6999,
    originalPrice: 11999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/rvgn35fn_IMG_0330.jpeg",
    category: "Silk Collection",
    discount: "42% OFF",
    rating: 4.8,
    reviews: 204
  },
  {
    id: 9,
    name: "Champagne Tissue Work Ensemble",
    price: 8499,
    originalPrice: 14999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/nj20j3rd_IMG_0331.jpeg",
    category: "Tissue Collection",
    discount: "43% OFF",
    rating: 5.0,
    reviews: 267
  },
  {
    id: 10,
    name: "Soft Pink Mirror Work Suit",
    price: 5499,
    originalPrice: 8999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/f2g3q6vq_IMG_0332.jpeg",
    category: "Pakistani Suits",
    discount: "39% OFF",
    rating: 4.7,
    reviews: 158
  },
  {
    id: 11,
    name: "Premium Gold Tissue Work Suit",
    price: 7499,
    originalPrice: 12999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ceavocb0_IMG_0408.jpeg",
    category: "Tissue Collection",
    discount: "42% OFF",
    rating: 4.9,
    reviews: 195
  },
  {
    id: 12,
    name: "Elegant Grey Party Wear Ensemble",
    price: 6999,
    originalPrice: 11499,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/hgp6zivg_IMG_0362.jpeg",
    category: "Party Wear",
    discount: "39% OFF",
    rating: 4.7,
    reviews: 134
  },
  {
    id: 13,
    name: "Turquoise Floral Stripe Pakistani Suit",
    price: 5999,
    originalPrice: 9999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/tdigxbbu_IMG_0244.jpeg",
    category: "Pakistani Suits",
    discount: "40% OFF",
    rating: 4.8,
    reviews: 142
  },
  {
    id: 14,
    name: "Red & White Floral Festive Suit",
    price: 6499,
    originalPrice: 10999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/qonhgkzz_IMG_0243.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 4.9,
    reviews: 178
  },
  {
    id: 15,
    name: "Black & White Stripe Floral Suit",
    price: 6299,
    originalPrice: 10499,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/t7v461ro_IMG_0242.jpeg",
    category: "Pakistani Suits",
    discount: "40% OFF",
    rating: 4.7,
    reviews: 165
  },
  {
    id: 16,
    name: "Yellow Floral Silk Festive Ensemble",
    price: 6999,
    originalPrice: 11999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ctgm57jj_IMG_0245.jpeg",
    category: "Silk Collection",
    discount: "42% OFF",
    rating: 4.9,
    reviews: 192
  },
  {
    id: 17,
    name: "Champagne Mirror Work Luxury Suit",
    price: 9499,
    originalPrice: 15999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/iez6hk7j_IMG_0179.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 5.0,
    reviews: 234
  },
  {
    id: 18,
    name: "Purple Mirror Work Festive Suit",
    price: 6999,
    originalPrice: 11999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/cl5ce75j_IMG_0145.jpeg",
    category: "Party Wear",
    discount: "42% OFF",
    rating: 4.9,
    reviews: 187
  },
  {
    id: 19,
    name: "Cream Pink Embroidered Silk Suit",
    price: 7499,
    originalPrice: 12999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/2nz2nspn_IMG_0156.jpeg",
    category: "Silk Collection",
    discount: "42% OFF",
    rating: 4.8,
    reviews: 203
  },
  {
    id: 20,
    name: "Olive Green Lace Work Suit",
    price: 8499,
    originalPrice: 14999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ipucthml_IMG_0119.jpeg",
    category: "Party Wear",
    discount: "43% OFF",
    rating: 5.0,
    reviews: 256
  },
  {
    id: 21,
    name: "Cream Patchwork Luxury Ensemble",
    price: 9999,
    originalPrice: 16999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/jn5blwb4_IMG_0100.jpeg",
    category: "Handpainted Collection",
    discount: "41% OFF",
    rating: 5.0,
    reviews: 278
  },
  {
    id: 22,
    name: "Yellow Red Festive Embroidered Suit",
    price: 6499,
    originalPrice: 10999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/g3j4r2th_IMG_0098.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 4.9,
    reviews: 215
  },
  {
    id: 23,
    name: "Copper Orange Embellished Gown",
    price: 12999,
    originalPrice: 21999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/mxfa3wcc_IMG_0034.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 5.0,
    reviews: 298
  },
  {
    id: 24,
    name: "Emerald Green Anarkali Suit",
    price: 9999,
    originalPrice: 16999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/yavwv10g_IMG_0030.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 5.0,
    reviews: 312
  },
  {
    id: 25,
    name: "Gold Silver Embroidered Suit",
    price: 7999,
    originalPrice: 13999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/vzxk7aev_IMG_0032.jpeg",
    category: "Silk Collection",
    discount: "43% OFF",
    rating: 4.9,
    reviews: 245
  },
  {
    id: 26,
    name: "Premium Designer Ensemble",
    price: 8999,
    originalPrice: 14999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/f3103956_93b1064a-39b0-417a-b27d-651e6d35e811.jpeg",
    category: "Party Wear",
    discount: "40% OFF",
    rating: 4.8,
    reviews: 267
  },
  {
    id: 27,
    name: "Elegant Festive Collection",
    price: 7499,
    originalPrice: 12499,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ghqxar5f_2374c35b-c4a6-4404-9943-c65746617292.jpeg",
    category: "Party Wear",
    discount: "40% OFF",
    rating: 4.8,
    reviews: 223
  },
  {
    id: 28,
    name: "Black Gold Embroidered Luxury Suit",
    price: 8999,
    originalPrice: 14999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/euqiqms1_IMG_9834.jpeg",
    category: "Velvet Collection",
    discount: "40% OFF",
    rating: 5.0,
    reviews: 289
  },
  {
    id: 29,
    name: "Elegant Traditional Ensemble",
    price: 7999,
    originalPrice: 13499,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ck8lmcv8_IMG_9827.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 4.9,
    reviews: 256
  },
  {
    id: 30,
    name: "Designer Festive Collection",
    price: 8499,
    originalPrice: 14499,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/jzfuznld_IMG_9826.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 4.8,
    reviews: 267
  },
  {
    id: 31,
    name: "Premium Embroidered Suit",
    price: 7499,
    originalPrice: 12999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/jd0zurjx_IMG_9825.jpeg",
    category: "Silk Collection",
    discount: "42% OFF",
    rating: 4.9,
    reviews: 234
  },
  {
    id: 32,
    name: "Luxury Festive Wear",
    price: 9499,
    originalPrice: 15999,
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/pwfg0qtw_IMG_9824.jpeg",
    category: "Party Wear",
    discount: "41% OFF",
    rating: 5.0,
    reviews: 301
  }
];

export const categories = [
  {
    id: 1,
    name: "Chanderi Collection",
    description: "Luxurious traditional handloom fabric",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/2nz2nspn_IMG_0156.jpeg",
    count: 85
  },
  {
    id: 2,
    name: "Muslin Suits",
    description: "Lightweight comfort with elegance",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ph9dqip8_IMG_0371.jpeg",
    count: 120
  },
  {
    id: 3,
    name: "Organza Suits",
    description: "Sheer sophistication and grace",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ceavocb0_IMG_0408.jpeg",
    count: 95
  },
  {
    id: 4,
    name: "Silk Collection",
    description: "Timeless luxury in every thread",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/vzxk7aev_IMG_0032.jpeg",
    count: 150
  },
  {
    id: 5,
    name: "Coords",
    description: "Modern matching sets",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ipucthml_IMG_0119.jpeg",
    count: 75
  },
  {
    id: 6,
    name: "Cotton Suits",
    description: "Everyday comfort and style",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/pr6y97xh_8A0A482A-1208-41D3-A02F-CC70B68ABFCD.png",
    count: 200
  },
  {
    id: 7,
    name: "Party Wear",
    description: "Dazzle at every celebration",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/yavwv10g_IMG_0030.jpeg",
    count: 110
  },
  {
    id: 8,
    name: "Georgette Collection",
    description: "Flowing elegance with rich drape",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/ph9dqip8_IMG_0371.jpeg",
    count: 130
  },
  {
    id: 9,
    name: "Pakistani Suits",
    description: "Contemporary ethnic charm",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/tdigxbbu_IMG_0244.jpeg",
    count: 90
  },
  {
    id: 10,
    name: "Tissue Collection",
    description: "Metallic sheen and opulence",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/nj20j3rd_IMG_0331.jpeg",
    count: 65
  },
  {
    id: 11,
    name: "Velvet Collection",
    description: "Regal texture for special occasions",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/euqiqms1_IMG_9834.jpeg",
    count: 70
  },
  {
    id: 12,
    name: "Handpainted Collection",
    description: "Artisanal masterpieces",
    image: "https://customer-assets.emergentagent.com/job_sari-showcase-2/artifacts/jn5blwb4_IMG_0100.jpeg",
    count: 45
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    comment: "Absolutely stunning quality! The bridal lehenga I ordered exceeded my expectations. The craftsmanship is impeccable.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Anjali Verma",
    location: "Delhi",
    rating: 5,
    comment: "Sachdeva Sons has become my go-to for all ethnic wear. Beautiful designs and excellent customer service!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Neha Patel",
    location: "Ahmedabad",
    rating: 4.5,
    comment: "The sarees are gorgeous and the fabric quality is premium. Delivery was prompt and packaging was elegant.",
    date: "3 weeks ago"
  }
];

export let cartItems = [];
export let wishlistItems = [];

export const addToCart = (product) => {
  const existingItem = cartItems.find(item => item.id === product.id);
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    cartItems.push({ ...product, quantity: 1 });
  }
  return cartItems;
};

export const removeFromCart = (productId) => {
  cartItems = cartItems.filter(item => item.id !== productId);
  return cartItems;
};

export const updateCartQuantity = (productId, quantity) => {
  const item = cartItems.find(item => item.id === productId);
  if (item) {
    item.quantity = quantity;
  }
  return cartItems;
};

export const addToWishlist = (product) => {
  if (!wishlistItems.find(item => item.id === product.id)) {
    wishlistItems.push(product);
  }
  return wishlistItems;
};

export const removeFromWishlist = (productId) => {
  wishlistItems = wishlistItems.filter(item => item.id !== productId);
  return wishlistItems;
};

export const getCartTotal = () => {
  return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const getCartCount = () => {
  return cartItems.reduce((count, item) => count + item.quantity, 0);
};

// Add default product details for products missing descriptions
export const getProductWithDetails = (product) => {
  if (product.fabric && product.style && product.color && product.work) {
    return product;
  }
  
  // Default details based on category
  const defaults = {
    fabric: "Premium quality fabric with luxurious finish",
    style: "Elegant traditional cut with modern silhouette",
    color: "Rich and vibrant color with intricate detailing",
    work: "Handcrafted embroidery with zari and embellishments",
    description: `This beautiful ${product.category} piece features exquisite craftsmanship and premium materials, perfect for special occasions and celebrations. The elegant design combines traditional artistry with contemporary style.`
  };
  
  return {
    ...product,
    ...defaults
  };
};